/** Maps SCAPI content sort ids (e.g. `name=asc`) to i18n keys under `categoryPlp:contentSortOptions`. */
export function contentSortIdToTranslationKey(sortId: string): string {
    const [attribute, direction] = sortId.split('=');
    if (!attribute || !direction) {
        return sortId;
    }

    const directionSuffix = direction === 'asc' ? 'Asc' : 'Desc';
    return `${attribute}${directionSuffix}`;
}

export function resolveContentSearchSort(sortFromUrl: string, configuredOptions?: Array<{ id: string }>): string {
    const configuredIds = configuredOptions?.map((option) => option.id) ?? [];

    if (configuredIds.length === 0) {
        return sortFromUrl;
    }

    if (sortFromUrl && configuredIds.includes(sortFromUrl)) {
        return sortFromUrl;
    }

    return '';
}
